import React from 'react';
import { Steps, Popover, Progress, Tooltip } from 'antd';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import services from '../../services';
import BoletimArtigoForm from '../common/Boletim_Artigo';
import Main from '../../Pages/Demo/main';
import Lang from '../../lang'
import LegalFrameWorkModal from '../common/matrixArticleModalForm'
import { Input } from '@progress/kendo-react-inputs';
import RowDeatils from '../common/RowDeatils';
import LocationSelection from '../common/LocationSelection';
import $ from 'jquery'
import ParcelVirsion from '../Parcel-Right-panel/ParcelVirsion';
import TlkTable from '../tlelrik/table/tlkTable';  
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteModal from '../common/delete_modal';
import BoletimModalCastas from '../common/Boletim_modal_Castas'

var moment = require('moment')
const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MMM/yyyy";

const { Step } = Steps;
const notify = () => toast("Para esta opção deve ser feito um Auto");
const customDot = (dot, { title }) => (
  <Popover
    content={
      <span>
        {title}
      </span>
    }
  >
    {dot}
  </Popover>
);

const castaKeyOrder = [
  "Casta",
  "Sinónimo",
  "Tipo Casta",
  "Cor",
  "Fator Castas",
  "Fator DO Porto",
  "Percentagem"
]


const castasInputs = {
  "percentagemTinta": "Casta tinta",
  "percentagemBranca": "Casta branca",
  "percentagemRose": "Casta rose",
  "percentagemMoscatel": "Casta moscatel"
};


const combolistrequest = {
  "Filters": null,
  "SortBy": "",
  "IsSortTypeDESC": true,
  "IsPagination": false,
  "Page": 2,
  "PageSize": 2
};

const intConst = {
  "anoPlantacao": 1,
  "area": 1,
  "codAgente1": 1,
  "codAgente2": 1,
  "idTpIrrigacao": 1,
  "idTpArmTerreno": 1,
  "idTpClassePlant": 1,
  "idTpCtutilizacao": 1,
  "geocodigo" : 1,
  "idTpCultura": 1,
  "idTpEstadoVinha": 1,
  "numProcesso": 1,
  "numTipoCultura": 1,
}

const ReadOnly = {
  'classe': 1,
  'areaeqlegal': 1,
  'areaeffective': 1,
  'areapotential': 1,
  'pestotals': 1,
  'prctfaults': 1,
  'prctLss3AndFailures': 1,
  'densidade': 1,
  'percentagemBranca': 1,
  'percentagemTinta': 1,
  'percentagemRose': 1,
  "percentagemMoscatel" : 1
}

const createTableModule = ["boletimAbrigo","boletimDetalhesPovoamento","boletimNaturezaTerreno","boletimPortaEnxertos","boletimPedregosidade",'boletimCompassoPlantacao',"boletimModoConducao"]


//>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> createTableModuleForCasta

const createTableModuleForCasta = ['boletimCastas', "boletimArtigoMatricial"];

//>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

const columnkeyMapObj = {
  "boletimAbrigo" : {
    "Classe" : "idTpAbrigo",
    "Percentagem": "percentagem"
  },
  "boletimNaturezaTerreno" : {
    "Classe": "idTpNaturTerr",
    "Percentagem": "percentagem"
  },
  "boletimPedregosidade": {
    "Classe": "idTpPedregosidade",
    "Percentagem": "percentagem"
  },
  "boletimCompassoPlantacao" :{
    "Linha 1 (cm)" : "linha1",
    "Linha 2 (cm)" : "linha2",
    "Linha 3 (cm)" : "linha3",
    "Entrelinha 1 (cm)" : "entreLinha1",
    "Entrelinha 2 (cm)" : "entreLinha2"
  },
  "boletimModoConducao" : {
    "Forma" : "idTpArmacao",
    "Tipo" : "idTpArmacaoForma",
    "Altura - 1º Arame (cm)" : "alturaArame1"
  },
  "boletimPortaEnxertos" : {
    "Tipo" : "idTpPortaEnxertos",
    "Percentagem (Tipo)" : "percentagem"
  },
  "boletimDetalhesPovoamento" :{
    "Bacelos" :"bacelos",
    "Enxertos (1 ano)" :"enxertos1",
    "Videiras (2 anos)" :"videiras2",
    "Videiras (3 anos)" :"videiras3",
    "Videiras (4-25 anos)" :"videiras4A25",
    "Videiras (> 25 anos)" :"videirasMaior25",
    "Falhas" : "falhas"
  },
  "boletimArtigoMatricial" : {
    "numArtigo" : "Nº Artigo",
    "fracao" : "Fração"
  }
}

class BoletimmainFrom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boletim: {
        administrativo: false,
        dataBoletim : new Date(),
        percentagemEnxertoPronto: null
      },
      data:{},
      datePicker: "",
      parceldata: {},
      portaPercentage: null,
      sel_nev: "parcel",
      detailPopUp: "",
      telkikTable: {},
      busentconcelho: [],
      BusEntFreguesia: [],
      Popupupdates: false,
      totalPct:{},
      artigoForm: '',
      urlassinaturaAgente1:'',
      urlassinaturaAgente2:'',
      allSelectedDropDown :{},
      "boletimAbrigo" : [
        {
          "idTpAbrigo" : null,
          "percentagem" : null
        }
      ],
      "boletimNaturezaTerreno": [
        {
          "idTpNaturTerr": null,
          "percentagem": null,
        }
      ],
      "boletimPedregosidade": [
        {
          "idTpPedregosidade": null,
          "percentagem": null,
        }
      ],
      boletimCompassoPlantacao:[
        {
          "linha1" : null,
          "linha2" : null,
          "linha3" : null,
          "entreLinha1" : null,
          "entreLinha2" : null
        }
      ],
      boletimModoConducao:[
        {
          "idTpArmacaoForma" : "",
          "idTpArmacao" : "",
          "alturaArame1" : ""
        }
      ],
      boletimPortaEnxertos:[
        {
          "idTpPortaEnxertos" : null,
          "percentagem" : null
        }
      ],
      boletimDetalhesPovoamento:[
        {
          "bacelos": null,
          "enxertos1": null,
          "videiras2": null,
          "videiras3": null,
          "videiras4A25": null,
          "videirasMaior25": null,
          "falhas": null,
        }
      ]
    }
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {

    this.setState({
      boletim: this.props.boletimData.boletim || {},
      data : this.props && this.props.boletimData || {},
      boletimDetalhesPovoamento : this.props.boletimData.boletimDetalhesPovoamento || [...this.state.boletimDetalhesPovoamento],
      boletimNaturezaTerreno : this.props.boletimData.boletimNaturezaTerreno || [...this.state.boletimNaturezaTerreno],
      boletimPedregosidade : this.props.boletimData.boletimPedregosidade || [...this.state.boletimPedregosidade],
      boletimAbrigo : this.props.boletimData.boletimAbrigo || [...this.state.boletimAbrigo],
      boletimPortaEnxertos : this.props.boletimData.boletimPortaEnxertos || [...this.state.boletimPortaEnxertos],
      boletimModoConducao : this.props.boletimData.boletimModoConducao || [...this.state.boletimModoConducao],
      boletimCompassoPlantacao : this.props.boletimData.boletimCompassoPlantacao || [...this.state.boletimCompassoPlantacao],
      
      // administrativo : this.props.boletimData && this.props.boletimData.boletim && this.props.boletimData.boletim.administrativo === 'Sim' ? true : false,
      all_list:this.props.all_list,
      activeIndex : "step" + (this.props.boletimData && this.props.boletimData.boletim && this.props.boletimData.boletim.idTpEstadoVinha || 0)
    }, () => {
      // this.castaCompleteForm()
      console.log("spidy did mount")
      console.log("spidy did mount the all list", this.state.all_list, this.props.all_list)
      
      ////console.log("the data in update is....", this.state.data)
      ////console.log("the data props in update is....", this.props.boletimData)
      createTableModule.map(_t => this.telrikTable(this.state[_t],_t))
      createTableModuleForCasta.map((_k, i) => {
        this.createOthersTables(_k);
      })
      this.setOtherDetails()
    })


  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> callback of setState for Casta 
  updateCallBack = () => {
    createTableModule.map(_t => this.telrikTable(this.state[_t],_t))
    createTableModuleForCasta.map((_k, i) => {
      this.createOthersTables(_k);
    })
    this.setOtherDetails()
  }


  componentDidUpdate(preprop) {
    if ((JSON.stringify(preprop.boletimData) !== JSON.stringify(this.props.boletimData))) {
      
      this.setState({
        boletim: this.props.boletimData.boletim || {},
        boletimDetalhesPovoamento : this.props.boletimData.boletimDetalhesPovoamento || [...this.state.boletimDetalhesPovoamento],
        boletimCompassoPlantacao : this.props.boletimData.boletimCompassoPlantacao || [...this.state.boletimCompassoPlantacao],
        boletimNaturezaTerreno : this.props.boletimData.boletimNaturezaTerreno || [...this.state.boletimNaturezaTerreno],
        boletimModoConducao : this.props.boletimData.boletimModoConducao || [...this.state.boletimModoConducao],
        boletimPortaEnxertos : this.props.boletimData.boletimPortaEnxertos || [...this.state.boletimPortaEnxertos],
        boletimPedregosidade : this.props.boletimData.boletimPedregosidade || [...this.state.boletimPedregosidade],
        boletimAbrigo : this.props.boletimData.boletimAbrigo || [...this.state.boletimAbrigo],
        data : this.props && this.props.boletimData || {},
        // administrativo : this.props.boletimData && this.props.boletimData.boletim && this.props.boletimData.boletim.administrativo === 'Sim' ? true : false,
        all_list : this.props.all_list,
        activeIndex : "step" + (this.props.boletimData && this.props.boletimData.boletim && this.props.boletimData.boletim.idTpEstadoVinha || 0)
      }, () => {
        this.updateCallBack()
      })
    }
    else if((JSON.stringify(this.state.all_list) !== JSON.stringify(this.props.all_list))) {
      this.setState({
        all_list: this.props.all_list
      }, () => {
        this.updateCallBack()
      })
    }
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> castaCompleteForm

  castaCompleteForm = () => {
    let data = { ...this.state.data }
    let formData = data['boletimCastas'] || []
    let castaobject = ["percentagemBranca", "percentagemTinta", "percentagemRose", "percentagemMoscatel"];
    if (!data['boletim']) {
      data['boletim'] = {}
    }
    castaobject.map((_row, index) => {
      data['boletim'][_row] = 0;
    })
    if (formData.length > 0 && this.props.all_list && this.props.all_list.Casta) {
      formData.map((_row, index) => {
        this.props.all_list.Casta.map((_crow, cindex) => {
          if (parseInt(_row.codCasta) === parseInt(_crow.codcasta)) {
            data['boletim'][castaobject[_crow.idcor - 1]] = parseInt(data['boletim'][castaobject[_crow.idcor - 1]]) + parseInt(_row.pctCasta);
          }
        })
      })
    }

    ////console.log("update before casra", data)

    this.setState({
      data
    },()=>{
      ////console.log("update in casra",this.props.boletimData, this.state.data)
    })
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> openArtigoForm

  openArtigoForm = () => {
    let modulename = "boletimArtigoMatricial";
    
    let artigoForm = ''
      artigoForm = (
        <BoletimArtigoForm date={new Date()} parcel={this.state.data} moduledata={this.state.data[modulename] || []} all_list={this.props.all_list} getpopUpdata={(data, modulename, index) => this.getpopUpdata(data, modulename, index)} closeForm={() => this.closeForm()} data={{}} tab={modulename} />
      )
      this.setState({
        artigoForm,
        sel_nev : modulename
      })
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> updatecastaForm

  updatecastaForm = (formData, data) => {
    let castaobject = ["percentagemBranca", "percentagemTinta", "percentagemRose", "percentagemMoscatel"];
    if (!data['boletim']) {
      data['boletim'] = {}
    }
    castaobject.map((_row, index) => {
      data['boletim'][_row] = 0;
    })

    formData.map((_row, index) => {
      this.props.all_list.Casta.map((_crow, cindex) => {
        if (parseInt(_row.codCasta) === parseInt(_crow.codcasta)) {
          data['boletim'][castaobject[_crow.idcor - 1]] = parseInt(data['boletim'][castaobject[_crow.idcor - 1]]) + parseInt(_row.pctCasta);
        }
      })
    })
    return data;
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> closePopup


  closePopup = () => {
    this.props.updatesel_nev(this.state.sel_nev)
    if (this.props.closePopup) {
      this.props.closePopup();
    }
  }


  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> makeInputs

  makeInputs = (data, parcelobject, keystring, type, index) => {
    return Object.keys(data).map((key) => (
      <div className="col-md-3" key={index} >
        <div className="input-box active-grey" key={index}>
          <Input
            type="text"
            key={index}
            style={{ width: "100%" }}
            readOnly={ReadOnly[key] ? true : false}
            className="input-1"
            name={key}
            value={parcelobject[key] ? parcelobject[key] : ''}
            label={Lang.langCheck.langRequest(`${data[key]}`)}
            onChange={(e) => this.handleChange(e, keystring, type)}
          />
        </div>
      </div>
    ));
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> createFinalForm

  createfinalform = (datafinal, keystring, type, parcelobject) => {
    return datafinal.map((_row, index) => (
      this.makeInputs(_row, parcelobject, keystring, type, index)
    ))
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> setOtherDetails

  setOtherDetails = () => {
    
    let CastasInputsdivs = this.createform(castasInputs, "boletim");

    let legalarray = [];

    this.setState({
      parcelGrapes: CastasInputsdivs,
    })
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> createForm

  createform = (data, keystring) => {
    let parcel = this.state.data;
    
    let datafinal = [];
    let type = -1;
    if (data && !Array.isArray(data)) {
      datafinal = [data];
    } else {
      type = 2;
      datafinal = data;
    }

    if (type === -1) {
      let parcelobject = parcel[keystring] ? parcel[keystring] : {};
      //console.log("test",this.state.data);
      //console.log("test",parcelobject);
      return this.createfinalform(datafinal, keystring, type, parcelobject);
    }
    if (type === 2) {
      let parcelobject = parcel[keystring] ? parcel[keystring] : [];
      if (parcelobject.length === 0) {
        parcelobject = datafinal
      }
      return parcelobject.map((_rowdata, index) => (
        this.createfinalform(datafinal, keystring, index, _rowdata)
      ))
    }
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> createOthersTables

  createOthersTables = (modulename) => {
    let data = { ...this.state.data }
    let langkey = ""
    if (data) {
      let module = data[modulename];

      if (module) {
        if (!Array.isArray(module)) {
          if (Object.keys(module).length === 0)
            return
          module = [module]
        }
        let telericdata = [];
        let telerikRow = {};
        module.map((_row, index) => (
          telerikRow = {},
          Object.keys(_row).map(function (key) {
            if (key === 'time') {
              _row[key] = moment(_row.date).format('LTS')
            } else if (key === 'date') {
              _row[key] = moment(_row.date).format('DD-MM-YYYY')
            }
            langkey = Lang.langCheck.langRequest(key);
            telerikRow[langkey] = _row[key]
          }),
          telericdata.push(telerikRow)
        ));
        this.telrikTable(telericdata, modulename)
      }
    }
  }


  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> openRightPopup

  openRightPopup = (modulename, sel_nev = "parcel") => {
    let detailPopUp = '';
    
      if(modulename === "boletimCastas") {
        
        detailPopUp = (
          <BoletimModalCastas 
            date={new Date()} 
            parcel={this.state.data} 
            moduledata={this.state.data[modulename] || []} all_list={this.props.all_list} 
            getpopUpdata={(data, modulename, index) => this.getpopUpdata(data, modulename, index)} 
            closePopup={() => this.closePopup()} 
            data={{}} 
            tab={modulename} 
          />
        )
      }
    this.setState({
      sel_nev: sel_nev,
      detailPopUp: detailPopUp
    }, () => {
      this.props.updatesel_nev(this.state.sel_nev)
    })
  }
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> closeForm

  closeForm = () => {
    this.setState({
      artigoForm : '' 
    })
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> getpopUpdata

  getpopUpdata = (formData, modulename) => {
    let {data} = { ...this.state }
    ////console.log("SubmitForm ", formData)
    if (modulename === "boletimCastas") {
      data[modulename]  = this.updatecastaForm(formData, data);
    }
    data[modulename] = formData;
    this.props.getcenterformdata(data)
    this.setState({
      data: data,
      Popupupdates: true
    }, () =>
    this.props.updatesel_nev(this.state.sel_nev));
  }

  //------------------------------------- 

  
  handleDisableClik() {
    let {data,boletim} = {...this.state}
    boletim['administrativo'] = !boletim['administrativo']
    data['boletim'] = {...boletim}
    this.setState( {data,boletim} )
  } 

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>handleAssinatura

  handleAssinatura = (e) => {
    let name = e.target.name
    let {boletim,data} = {...this.state}
    boletim[name] = e.target.files[0]
    data['boletim'] = {...boletim}
    this.setState({
      ['url'+name] : URL.createObjectURL(e.target.files[0]),
      boletim,
      data
    },()=>this.props.getcenterformdata(data))
  }

  handleChange = (e, modulename, type) => {
    let key = e.target.name;
    let value = null;
    if(intConst[key]){
        console.log("date if block")
        value = !isNaN(+e.target.value) ? +e.target.value : ""
    }else{
        console.log("date else block")
        
        // if(e.target.name === "dataBoletim") {
        //     //console.log("the time you selected is....", e.target.name)
        //     let date = new Date()
        //     let milliCurrentSeconds = date.getTime()
        //     let milliEventSeconds = e.target.value.getTime()
        //     if(milliCurrentSeconds > milliEventSeconds) {
        //         value = e.target.value
        //         console.log("date changed")
        //     }
        //     else return
        // }
        value = e.target.value
    }
    
    let {data,boletim} = this.state
    if(modulename === 'boletim'){
      //console.log("---------------======================== change")
      boletim[key] = key === 'dataBoletim' ? services.Converter.dateConvert(e.target.value,dateFormat) :value
    }
    data[modulename] = {...boletim}

    this.setState({
      data,
      boletim
    },()=>this.props.getcenterformdata(data))
  }

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>handleDeleteAssinature
  handleDeleteAssinature = ({fileName,selectName}) => {
    let {data, boletim} = {...this.state}
    delete boletim[fileName]
    delete boletim[selectName]
    data['boletim'] = {...boletim}
    this.setState({
      boletim,
      data,
      ['url'+fileName] : ''
    },()=>this.props.getcenterformdata(data))
  }

  fieldCalculation = () => {
    return 0;
  }

  handleDate = (e) => {
    let {data,boletim} = { ...this.state }
    boletim['dataBoletim'] = e && e._d && moment(e._d).format(dateFormat)
    data['boletim'] = {...boletim}
    this.setState({
      data,
      boletim
    },()=>this.props.getcenterformdata(data))
  }

  handleSteps = (e, modulename, index) => {
    this.setState({ activeIndex: 'step' + e })
    let key = "idTpEstadoVinha";
    let value = e;
    let {boletim,data} = { ...this.state };
    boletim[key] = value
    data[modulename] = {...boletim}
    this.setState({
      data,
      boletim
    },()=>this.props.getcenterformdata(data))
  }

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>. addNewRow
  addNewRow = (type) => {
    let {data} = {...this.state}
    if(type === "Detalhes do Povoamento"){
      let {boletimDetalhesPovoamento} = {...this.state}
      if(!this.checkAddRowOrNot(boletimDetalhesPovoamento)) return; 
      boletimDetalhesPovoamento.push({
        "bacelos": null,
        "enxertos1": null,
        "videiras2": null,
        "videiras3": null,
        "videiras4A25": null,
        "videirasMaior25": null,
        "falhas": null,
      })
      data['boletimDetalhesPovoamento'] = boletimDetalhesPovoamento
      this.setState({boletimDetalhesPovoamento},()=>{
        this.telrikTable(this.state.boletimDetalhesPovoamento,"boletimDetalhesPovoamento")
        this.props.getcenterformdata(data)
      })
    }
    if(type === "Compasso Plantação"){
      let {boletimCompassoPlantacao} = {...this.state}
      if(!this.checkAddRowOrNot(boletimCompassoPlantacao)) return;
      boletimCompassoPlantacao.push({
        "linha1" : null,
        "linha2" : null,
        "linha3" : null,
        "entreLinha1" : null,
        "entreLinha2" : null
      })
      data['boletimCompassoPlantacao'] = boletimCompassoPlantacao
      this.setState({boletimCompassoPlantacao},()=>{
        this.telrikTable(this.state.boletimCompassoPlantacao,"boletimCompassoPlantacao")
        this.props.getcenterformdata(data)
      })
    }
  }

  checkAddRowOrNot = (moduleData) => {
    let dataLength = moduleData.length-1
    let lastRow = moduleData[dataLength]
    let dataKeys = Object.keys(lastRow)
    let cond = false
    for (let i = 0; i < dataKeys.length; i++) {
      const k = dataKeys[i];
      if(k === 'index' || k === 'modulename') continue;
      else if(lastRow[k]) cond = true
    }
      
    return cond;
  }

  telrikTable = (data, modulename) => {
    let allSelectedDropDown = {...this.state.allSelectedDropDown}
    let columnkeyMap = {}
    let totalPercentage = 0
    let {totalPct} = {...this.state}
    let noExport = true
    let collepsview = false
    if (modulename === 'boletimCastas') {
      //console.log("boletimCastas",data);
      collepsview = true
      noExport = true
    }
    if (data && data.length > 0) {
      if (modulename === 'boletimCastas') {
        data.map((_r, i) => {
          //console.log("rowwwwwwwwwwwwwwwwwwwwwwwwww",_r)
          if (this.props.all_list.Casta && this.props.all_list.Casta.length > 0) {
            let casta = this.props.all_list.Casta.filter(_c => _c.codcasta == _r.CodCasta)
            
            if (casta.length > 0) _r['Casta'] = casta[0].descasta
            else _r['Casta'] = '';
          }
          if (this.props.all_list.colors && this.props.all_list.colors.length > 0) {
            let cor = this.props.all_list.colors.filter(_c => _c.idcor == _r.IdCor)
            if (cor.length > 0) _r['Cor'] = cor[0].descor
            else _r['Cor'] = '';
          }
          if (this.props.all_list.Sinonimo && this.props.all_list.Sinonimo.length > 0) {
            let Sinonimo = this.props.all_list.Sinonimo.filter(_c => _c.idsinonimo == _r.IdSinonimo)
            if (Sinonimo.length > 0) _r['Sinónimo'] = Sinonimo[0].descasta
            else _r['Sinónimo'] = '';
          }
        })
      }
      data[0] && Object.keys(data[0]).map((_k, j) => {
        if (modulename === 'boletimCastas') {
          if (_k === 'Casta' || _k === 'Percentagem' || _k === 'Cor') {
            columnkeyMap[_k] = Lang.langCheck.langRequest(_k)
          }
        }
      })

      if(modulename === 'boletimDetalhesPovoamento' ||  modulename === 'boletimNaturezaTerreno' || modulename === 'boletimCompassoPlantacao' || modulename === 'boletimPedregosidade' || modulename === 'boletimAbrigo' || 
      modulename === 'boletimPortaEnxertos' || modulename === 'boletimModoConducao'){
        Object.keys(columnkeyMapObj[modulename]).map(key => {
          columnkeyMap[columnkeyMapObj[modulename][key]] = key
        })
      }

      data.map((row, index) => {
        row.index = index
        row.modulename = modulename
      })
      let actionbuttons = { Delete: true }
      let telkikTable = this.state.telkikTable

      // if() {
      //   columnkeyMap = columnkeyMapObj['boletimAbrigo']
      // }

      if(modulename === 'boletimArtigoMatricial'){
          columnkeyMap = columnkeyMapObj[modulename]
      }


      let columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
      });
      
      if (modulename === 'legalFramework') {
        actionbuttons = { ...actionbuttons, LegalPopup: true }
      }else{
        if(modulename === 'boletimAbrigo' || 
          modulename === 'boletimPedregosidade' || 
          modulename === 'boletimNaturezaTerreno' ||
          modulename === 'boletimPortaEnxertos' ){
          data.map((_r,index)=> {
            _r.index = index
            _r.totalCount = data.length
            totalPercentage += parseFloat(_r.percentagem || 0)
          })
        }

        if(!allSelectedDropDown[modulename]){
          let selectedDropDown = []
          data.map((_r,i) => {
            if(modulename === 'boletimAbrigo') selectedDropDown.push(_r.idTpAbrigo)
            else if(modulename === 'boletimPedregosidade') selectedDropDown.push(_r.idTpPedregosidade)
            else if(modulename === 'boletimNaturezaTerreno') selectedDropDown.push(_r.idTpNaturTerr)
            else if(modulename === 'boletimPortaEnxertos') selectedDropDown.push(_r.idTpPortaEnxertos)
            else if(modulename === 'boletimModoConducao'){
              selectedDropDown.push(_r.idTpArmacao)
              this.getTipoList(_r.idTpArmacao, _r.index, data, allSelectedDropDown)
              console.log("tipo called block++++++++++++++++++", _r,i)
            }
          })
          allSelectedDropDown[modulename] = selectedDropDown
        }

        totalPct[modulename] = totalPercentage
        
        telkikTable[modulename] =  <Main
          viewFor={"casta"} 
          collepsview={collepsview}
          notGroup={true} 
          key={Object.keys(telkikTable).length}
          list={data}
          noExport={true}
          noDownloadButton={true} 
          castaKeyOrder={castaKeyOrder}
          notAction={false} 
          noFooter={true}
          customClass= "noGroupHeaderClass"
          date={new Date()}
          all_list={this.state.all_list}
          totalPercentage={totalPercentage}
          actionbuttons={actionbuttons}
          pageable={false} 
          columnkeyMap={columnkeyMapObj[modulename]}
          modulename={modulename} 
          columnWidth={true}
          selectedDropDown={allSelectedDropDown[modulename]}
          columnlist={columnlist} 
          noFilterShow={true}
          percentagemEnxertoPronto={this.state.data.boletim.percentagemEnxertoPronto}
          deleteFunc={(id) => this.deleteFunc(id)}
          ActionPerform={(action, id,fieldName,selectedDropDown) => this.ActionPerform(action, id,fieldName,selectedDropDown)} 
        />
      }

      this.setState({
        telkikTable: telkikTable,
        totalPct
      });
    }
  }

  deleteFunc = (_row) => {
    let data = { ...this.state.data };
    let allSelectedDropDown = {...this.state.allSelectedDropDown}
    if(_row.modulename === 'boletimArtigoMatricial' || _row.modulename === 'boletimCastas'){
      data[_row.modulename].splice(_row.index, 1);
      let telkikTable = { ...this.state.telkikTable }
      telkikTable[_row.modulename] = null;
      this.setState({
        data,
        telkikTable
      }, () => {
        this.castaCompleteForm()
        this.createOthersTables(_row.modulename)
        this.props.getcenterformdata(data)
      })
    }else{
      let moduleData = this.state[_row.modulename]
      if(moduleData && moduleData.length === 1){
        Object.keys(moduleData[_row.index]).map(_k => {
          if(_k === "index" || _k === 'modulename' || _k === 'totalCount'){
            return;
          }else{
            moduleData[_row.index][_k] = null
          }
        })
      }else{
        moduleData.splice(_row.index,1);
      }

      let updatedSelectedDropDown = allSelectedDropDown[_row.modulename]
      if(updatedSelectedDropDown && updatedSelectedDropDown.length > 0){
        updatedSelectedDropDown.splice(_row.index,1)
      }

      allSelectedDropDown[_row.modulename] = updatedSelectedDropDown

      data[_row.modulename] = moduleData
      let telkikTable = { ...this.state.telkikTable }
      telkikTable[_row.modulename] = null;
      this.setState({
        data,
        [_row.modulename] : moduleData,
        telkikTable,
        allSelectedDropDown
      },()=>{
        this.telrikTable(this.state[_row.modulename],_row.modulename)
        this.props.getcenterformdata(data)
      })
    }

    return true;
  }

  ActionPerform = (action, row,fieldName, selectedDropDown = []) => {
    let {data, allSelectedDropDown} = {...this.state}
    ////console.log("ACtionPerfoem Callllll")
    let newSelectedDropDown = [...selectedDropDown]
    if(action === 'boletimAbrigo'){
      let boletimAbrigo = this.state[action]
      let newArr = []
      boletimAbrigo[row.index] = row
      if(row.percentagem <= 0 || row.percentagem == ''){
        // //console.log("ROWSSSSSSSSSSSSSSSSSSS",row)
        // return;
        boletimAbrigo.slice(row.index,1)
      }
      // //console.log("ROWSSSSSSSSSSSSSSSSSSS",boletimAbrigo)
      boletimAbrigo.map((_r,index) => {
        if((_r.percentagem > 0)){
          newArr[index] = _r
        }
      })

      if(!!boletimAbrigo[boletimAbrigo.length - 1].idTpAbrigo && !boletimAbrigo[boletimAbrigo.length - 1].percentagem){
        newArr.push(boletimAbrigo[boletimAbrigo.length - 1])
      }else{
        newArr.push({
          "idTpAbrigo" : null,
          "percentagem" : null
        })
      }

      if(newArr[row.index] && !newArr[row.index].percentagem && !newArr[row.index].idTpAbrigo){
        newSelectedDropDown.splice(row.index,1)
      }

      data['boletimAbrigo'] = newArr
      allSelectedDropDown[action] = newSelectedDropDown
      this.setState({boletimAbrigo : newArr, allSelectedDropDown, data},()=> {
        this.telrikTable(this.state.boletimAbrigo,action)
        this.props.getcenterformdata(data)
      })
    }else if(action === 'boletimCompassoPlantacao'){
      
      let boletimCompassoPlantacao = this.state.boletimCompassoPlantacao
      let newArr = []
      boletimCompassoPlantacao[row.index] = row
      boletimCompassoPlantacao.map((_r,index) => {
          newArr[index] = _r
      })

      data['boletimCompassoPlantacao'] = newArr
      this.setState({boletimCompassoPlantacao : newArr},()=>{
        this.telrikTable(this.state.boletimCompassoPlantacao,action)
        this.props.getcenterformdata(data)
      })
    
    }else if(action === 'boletimModoConducao'){
      let boletimModoConducao = this.state.boletimModoConducao
      let newArr = []
      if(fieldName === 'idTpArmacao'){
        row.idTpArmacaoForma = ''  
        ////console.log(">>>>>>>>>>>>>>>>>>======>>>>>>>>>>> row in boletim", row)
      }
      boletimModoConducao[row.index] = row
      // if(row['Linha 1 (cm)'] <= 0 || row['Linha 1 (cm)'] == ''){
      //   boletimModoConducao.slice(row.index,1)
      // }
      boletimModoConducao.map((_r,index) => {
        ////console.log(">>>>>>>>><<<<<<>>>>>>>>>> Arame1 ", _r.alturaArame1)
        ////console.log(">>>>>>>>><<<<<<>>>>>>>>>> newArr ", newArr)
        if((_r.alturaArame1 > 0)){
          newArr[index] = _r
        }
      })


      if((!!boletimModoConducao[boletimModoConducao.length - 1].idTpArmacao || !!boletimModoConducao[boletimModoConducao.length - 1].idTpArmacaoForma) && !boletimModoConducao[boletimModoConducao.length - 1].alturaArame1){
        newArr.push(boletimModoConducao[boletimModoConducao.length - 1])
      }else{
        newArr.push({
          "idTpArmacaoForma" : "",
          "idTpArmacao" : "",
          "alturaArame1" : ""
        })
      }

      data['boletimModoConducao'] = newArr
      allSelectedDropDown[action] = newSelectedDropDown
      if(fieldName === 'idTpArmacao'){
        this.getTipoList(row.idTpArmacao, row.index, newArr, allSelectedDropDown) 
      }else{
        this.setState({boletimModoConducao : newArr, allSelectedDropDown, data},()=>{
          this.telrikTable(this.state.boletimModoConducao,action)
          this.props.getcenterformdata(data)
        })
      }
    }
    
    //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>..start
    else if(action === 'boletimPedregosidade'){
      let boletimPedregosidade = this.state.boletimPedregosidade
      let newArr = []
      boletimPedregosidade[row.index] = row
      if(row.percentagem <= 0 || row.percentagem == ''){
        boletimPedregosidade.slice(row.index,1)
        ////console.log("kokokoko",boletimPedregosidade,row)
      }
      boletimPedregosidade.map((_r,index) => {
        if((_r.percentagem > 0)){
          newArr[index] = _r
        }
      })
      if(!!boletimPedregosidade[boletimPedregosidade.length - 1].idTpPedregosidade && !boletimPedregosidade[boletimPedregosidade.length - 1].percentagem){
        newArr.push(boletimPedregosidade[boletimPedregosidade.length - 1])
      }else{
        newArr.push({
          "idTpPedregosidade" : "",
          "percentagem" : ""
        })
      }
      if(!newArr[row.index].percentagem && !newArr[row.index].idTpPedregosidade){
        newSelectedDropDown.splice(row.index,1)
      }
      data['boletimPedregosidade'] = newArr
      allSelectedDropDown[action] = newSelectedDropDown
      this.setState({boletimPedregosidade : newArr, allSelectedDropDown, data},()=> {
        this.telrikTable(this.state.boletimPedregosidade,action)
        this.props.getcenterformdata(data)
      })
    }
    //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> end



    else if(action === 'boletimNaturezaTerreno'){
      let boletimNaturezaTerreno = this.state.boletimNaturezaTerreno
      let newArr = []
      boletimNaturezaTerreno[row.index] = row
      if(row.percentagem <= 0 || row.percentagem == ''){
        boletimNaturezaTerreno.slice(row.index,1)
       // //console.log("kokokoko",boletimNaturezaTerreno,row)
      }
      boletimNaturezaTerreno.map((_r,index) => {
        if((_r.percentagem > 0)){
          newArr[index] = _r
        }
      })
      if(!!boletimNaturezaTerreno[boletimNaturezaTerreno.length - 1].idTpNaturTerr && !boletimNaturezaTerreno[boletimNaturezaTerreno.length - 1].percentagem){
        newArr.push(boletimNaturezaTerreno[boletimNaturezaTerreno.length - 1])
      }else{
        newArr.push({
          "idTpNaturTerr" : "",
          "percentagem" : ""
        })
      }
      if(!newArr[row.index].percentagem && !newArr[row.index].idTpNaturTerr){
        newSelectedDropDown.splice(row.index,1)
      }
      data['boletimNaturezaTerreno'] = newArr
      allSelectedDropDown[action] = newSelectedDropDown
      this.setState({boletimNaturezaTerreno : newArr, allSelectedDropDown, data},()=> {
        this.telrikTable(this.state.boletimNaturezaTerreno,action)
        this.props.getcenterformdata(data)
      })
    }



    else if(action === 'boletimPortaEnxertos'){
      let boletimPortaEnxertos = this.state.boletimPortaEnxertos
      let newArr = []
      boletimPortaEnxertos[row.index] = row
      if(row.percentagem <= 0 || row.percentagem == ''){
        boletimPortaEnxertos.slice(row.index,1)
        ////console.log("kokokoko",boletimPortaEnxertos,row)
      }
      boletimPortaEnxertos.map((_r,index) => {
        if((_r.percentagem > 0)){
          newArr[index] = _r
        }
      })

      if(!!boletimPortaEnxertos[boletimPortaEnxertos.length - 1].idTpPortaEnxertos && !boletimPortaEnxertos[boletimPortaEnxertos.length - 1].percentagem){
        newArr.push(boletimPortaEnxertos[boletimPortaEnxertos.length - 1])
      }else{
        newArr.push({
          "idTpPortaEnxertos" : "",
          "percentagem" : ""
        })
      }
      if(!newArr[row.index].percentagem && !newArr[row.index].idTpPortaEnxertos){
        newSelectedDropDown.splice(row.index,1)
      }

      data['boletimPortaEnxertos'] = newArr
      allSelectedDropDown[action] = newSelectedDropDown
      this.setState({boletimPortaEnxertos : newArr, allSelectedDropDown, data},()=> {
        this.telrikTable(this.state.boletimPortaEnxertos,action)
        this.props.getcenterformdata(data)
      })
    }
    else if(action === 'boletimDetalhesPovoamento'){
      let boletimDetalhesPovoamento = [...this.state.boletimDetalhesPovoamento]
      let newArr = []
      boletimDetalhesPovoamento[row.index] = row
      boletimDetalhesPovoamento.map((_r,index) => {
          newArr[index] = _r
      })

      data['boletimDetalhesPovoamento'] = newArr
      this.setState({data , boletimDetalhesPovoamento : newArr},()=>{
        this.telrikTable(this.state.boletimDetalhesPovoamento,action)
        this.props.getcenterformdata(data)
      })
    }
    else{
      this.showRowDeatils(action, row);
    }
  }

  getTipoList = async(id,index,newArr, allSelectedDropDown) => {
    let { all_list , data} = {...this.state}
    let filters = {
      "Filters": null,
      "SortBy": "",
      "IsSortTypeDESC": false,
      "IsPagination": false,
      "Page": 2,
      "PageSize": 2,
      "id" : +id
  }
    let tipoList =  await services.apiCall.requestApi('/allservice/Tipo',filters,'post')
    all_list['Tipo'] = tipoList
    newArr.map((_r, i) =>{
      if(_r.index === index){
        _r.tipo = tipoList
      }
    })
    
    data['boletimModoConducao'] = newArr
    this.setState({
      all_list,
      boletimModoConducao : newArr,
      allSelectedDropDown,
      data
    },()=>{
      this.telrikTable(this.state.boletimModoConducao,'boletimModoConducao')
      this.props.getcenterformdata(data)
    })
  }

  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  handlePortaPercentage = (e, modulename) => {
    if(isNaN(+e.target.value)){
      return
      
    }else {
      let key = e.target.name;
      let value = e.target.value;
      let {data} = this.state
      let {boletim} = this.state.data
      if(modulename === 'boletim'){
        boletim[key] = value
      }
      data[modulename] = {...boletim}

      this.setState({
        data,
        boletim
      },()=>this.props.getcenterformdata(data))
    }
    
  }


  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  getLocationData = (key, value) => {
    let {data,boletim} = { ...this.state };
    if (key === 'distrito_id') {
      boletim['codDistrito'] = +value;
      boletim["codConcelho"] = null;
      boletim["codFreguesia"] =null;
    } else if (key === 'country_id') {
      boletim["codConcelho"] = +value;
      boletim["codFreguesia"] = null;
    } else if (key === 'fregusia_id') {
      boletim["codFreguesia"] = +value;
    }
    data['boletim'] = {...boletim}
    this.setState({
      boletim: boletim,
      data : data
    })
    return true;
  }


  /*  para renderizar o conteúdo html da página   */
  render() {

    return (
      <div className="right-section">
        <div className="bg-white middle p20" id="parcel">
          <form className="parcelforms" rel={'parcel'} data={-1}>
            <div className="head mb-4">
              <h2>Dados Gerais</h2>
            </div>
            <div className="row">
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                  style={{ width: '100%' }}
                    className="input-1 w-100"
                    name="numProcesso"
                    readOnly={this.props.isEnable("numProcesso")}
                    value={this.state.boletim.numProcesso || ''}
                    label="Nº de Processo"
                    disabled = {(this.state.boletim.administrativo)? "disabled" : ""}
                    onChange={(e) => this.handleChange(e, 'boletim')}
                  />
                  <div className="form-text">
                    <div className="custom-control custom-checkbox m-0">
                      <input type="checkbox" checked={this.state.boletim.administrativo} onClick = {this.handleDisableClik.bind(this)} className="custom-control-input" id="boletimAdministrativoCheck" name="administrativo"/>
                      <label className="custom-control-label" htmlFor="boletimAdministrativoCheck">Boletim Administrativo</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="geocodigo"
                    value={+this.state.boletim.geocodigo || ''}
                    readOnly={this.props.isEnable("geocodigo")}
                    label="Geocódigo"
                    onChange={(e) => this.handleChange(e, 'boletim')}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input-box active-grey">
                  <Input
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numBoletim"
                    value={this.state.boletim.numBoletim || ''}
                    readOnly={this.props.isEnable("numBoletim")}
                    disabled={"disabled"}
                    label="Nº de Boletim"
                    onChange={(e) => this.handleChange(e, 'boletim')}
                  />
                </div>
              </div>
            </div>
            <div className="row mt_20">
              <div className="col-md-12">
                <div className="form-group">
                  <div className="input-box active-grey">
                    <label className="input-label">Designação</label>
                    <textarea onChange={(e) => this.handleChange(e, 'boletim')}
                      className="form-control heigh-auto" rows="3"
                      readOnly={this.props.isEnable("designacao")}
                      name="designacao" defaultValue={this.state.boletim.designacao}></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
            <LocationSelection
              getLocationData={(key, value) => this.getLocationData(key, value)}
              date={new Date()}
              distrito_id={this.state.boletim && this.state.boletim.codDistrito || ''}
              country_id={this.state.boletim && this.state.boletim.codConcelho || ''}
              fregusia_id={this.state.boletim && this.state.boletim.codFreguesia || ''}
            />
            </div>
            
            <div className="row mt_20">
              <div className="col-md-12">
                <div className="progress-box">
                  <div className="title">Estado da vinha</div>
                  <div className="inner-box">
                    <Steps current={this.state.boletim.idTpEstadoVinha} onChange={(e) => this.handleSteps(e, 'boletim')} progressDot={customDot}>
                      <Step title="Indefinido" description="" className={this.state.activeIndex} />
                      <Step title="Em decadência" onClick={notify} description="" className={this.state.activeIndex} />
                      <Step title="Fraco" description="" className={this.state.activeIndex} />
                      <Step title="Regular" description="" className={this.state.activeIndex} />
                      <Step title="Bom" description="" className={this.state.activeIndex} />
                    </Steps>
                  </div>
                </div>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-6">
                <div className="input-box active-grey">
                  <Input
                    type="text"
                    style={{ width: "100%" }}
                    className="input-1"
                    name="area"
                    disabled
                    readOnly={this.props.isEnable("area")}
                    value={this.state.boletim.area || ''}
                    label="Área"
                    onChange={(e) => this.handleChange(e, 'boletim')}
                  />
                </div>
              </div>
              <div className="col-md-6 kendo-Input">
                <div className="input-box active-grey drop-down-box">
                  <label className="input-label">Irrigação</label>
                  <select className="custome-drop-down" onChange={(e) => this.handleChange(e, 'boletim')} value={this.state.boletim.idTpIrrigacao} name='idTpIrrigacao'>
                    <option value="">Selecione Situação de litígio </option>
                    {
                      this.props.all_list.Irrigacao &&
                      this.props.all_list.Irrigacao.map((_row, index) => (
                        <option value={_row.idtpirrigacao} key={index} >{_row.descr}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-box active-grey">
                  <Input
                    type="text"
                    style={{ width: "100%" }}
                    className="input-1"
                    name="anoPlantacao"
                    value={this.state.boletim.anoPlantacao || ''}
                    label="Ano de plantação"
                    onChange={(e) => this.handleChange(e, 'boletim')}
                  />
                </div>
              </div>
              <div className="col-md-6 kendo-Input">
                <div className="input-box active-grey drop-down-box">
                  <label className="input-label">Classe de Plantação</label>
                  <select className="custome-drop-down" onChange={(e) => this.handleChange(e, 'boletim')} name="idTpClassePlant" value={this.state.boletim.idTpClassePlant}>
                    <option value="">Selecione Classe de Plantação </option>
                    {
                      this.props.all_list.ClassPlantation &&
                      this.props.all_list.ClassPlantation.map((_row, index) => (
                        <option value={_row.idClassePlant} key={index}>{_row.desclassePlant}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-box active-grey">
                  <Input
                    type="text"
                    style={{ width: "100%" }}
                    className="input-1"
                    name="numTipoCultura"
                    value={this.state.boletim.numTipoCultura || ''}
                    label="Tipo de Cultura (Nº de Árvores)"
                    onChange={(e) => this.handleChange(e, 'boletim')}
                  />
                </div>
              </div>
              <div className="col-md-6 kendo-Input">
                <div className="input-box active-grey drop-down-box">
                  <label className="input-label">Tipo de Cultura</label>
                  <select className="custome-drop-down" onChange={(e) => this.handleChange(e, 'boletim')} name='idTpCultura' value={this.state.boletim.idTpCultura || ""}>
                    <option value="" disabled>Selecione Tipo de Cultura </option>
                    {
                      this.props.all_list.Cultura &&
                      this.props.all_list.Cultura.map((_row, index) => (
                        <option value={_row.idtpcultura} key={index}>{_row.descr}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className="col-md-6 kendo-Input">
                <div className="input-box active-grey drop-down-box">
                  <label className="input-label">Armação do Terreno</label>
                  <select className="custome-drop-down" onChange={ (e) => this.handleChange(e, 'boletim') } name='idTpArmTerreno' value={ this.state.boletim.idTpArmTerreno || "" }>
                    <option value="" disabled>Selecione Armação do Terreno </option>
                    {
                      this.props.all_list.Armterreno &&
                      this.props.all_list.Armterreno.map((_row, index) => (
                        <option value={ _row.idtparmterreno } key={ index }>{ _row.descr }</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className="col-md-6 kendo-Input">
                <div className="input-box active-grey drop-down-box">
                  <label className="input-label">Categoria Utilização</label>
                  <select className="custome-drop-down" onChange={ (e) => this.handleChange(e, 'boletim') } name='idTpCtutilizacao' value={ this.state.boletim.idTpCtutilizacao || "" }>
                    <option value="" disabled>Selecione Categoria Utilização </option>
                    {
                      this.props.all_list.Utilizacao &&
                      this.props.all_list.Utilizacao.map((_row, index) => (
                        <option value={ _row.idtpctutilizacao } key={ index }>{ _row.descr }</option>
                      ))
                    }
                  </select>
                </div>
              </div>
            </div>
          </form>

        </div>

        <div className="bg-white middle p20 mt-140 position-relative" id="parcelPointFactors">
          {/* <Tooltip title="Inserir Casta" color={"#333"}>
            <span data-toggle="modal" data-target='#left-popup-center' onClick={() => this.openRightPopup("boletimCastas", "Castas")} className="add-plus cursor-pointer"><i className="fas fa-plus"></i></span>
          </Tooltip> */}
          <div className="head mb-4">
            <h2>Factores de Pontuação</h2>
          </div>
          <div className="row" id="Abrigo" >
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p className="lead mb-0"><strong>Abrigo</strong></p>
                  <span class={`py-1 px-3 ${this.state.totalPct.boletimAbrigo > 0 && this.state.totalPct.boletimAbrigo <= 100 ? 'bg-success' : 'bg-danger' } text-white`}>{(this.state.totalPct.boletimAbrigo && (this.state.totalPct.boletimAbrigo).toFixed(2)) || 0}%</span>
                </div>
                <hr />
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimAbrigo
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p id="Natureza_do_Terreno" className="lead mb-0"><strong>Natureza do Terreno</strong></p>
                  <span class={`py-1 px-3 ${this.state.totalPct.boletimNaturezaTerreno > 0 && this.state.totalPct.boletimNaturezaTerreno <= 100 ? 'bg-success' : 'bg-danger'} text-white`}>{(this.state.totalPct.boletimNaturezaTerreno && (this.state.totalPct.boletimNaturezaTerreno).toFixed(2)) || 0}%</span>
                </div>
                <hr />
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimNaturezaTerreno
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p id="Pedregosidade" className="lead mb-0"><strong>Pedregosidade</strong></p>
                  <span class={`py-1 px-3 ${this.state.totalPct.boletimPedregosidade > 0 && this.state.totalPct.boletimPedregosidade <= 100 ? 'bg-success' : 'bg-danger'} text-white`}>{(this.state.totalPct.boletimPedregosidade && (this.state.totalPct.boletimPedregosidade).toFixed(2)) || 0}%</span>
                </div>
                <hr />
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimPedregosidade
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p id="Compasso_Plantação" className="lead mb-0"><strong>Compasso Plantação</strong></p>
                  <Tooltip title="Adicionar Nova Linha" color={"#333"}>
                    <span onClick={() => this.addNewRow("Compasso Plantação")} className="add-plus mr-3 cursor-pointer"><i className="fas fa-plus"></i></span>
                  </Tooltip>
                </div>
                <hr />
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimCompassoPlantacao
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p id="Modo_Condução" className="lead mb-0"><strong>Modo de Condução</strong></p>
                  {/* <span class="py-1 px-3 bg-success text-white">100%</span> */}
                </div>
                <hr />
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimModoConducao
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p id="Porta_Enxertos" className="lead mb-0"><strong>Porta Enxertos</strong></p>
                  <span class={`py-1 px-3 ${(this.state.totalPct.boletimPortaEnxertos + Number(!!this.state.boletim.percentagemEnxertoPronto ? this.state.boletim.percentagemEnxertoPronto : 0) > 0) && (this.state.totalPct.boletimPortaEnxertos + Number(!!this.state.boletim.percentagemEnxertoPronto ? this.state.boletim.percentagemEnxertoPronto : 0) <= 100) ? 'bg-success' : 'bg-danger'} text-white`}>{this.state.totalPct.boletimPortaEnxertos + Number(!!this.state.boletim.percentagemEnxertoPronto ? this.state.boletim.percentagemEnxertoPronto : 0)}%</span>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p><strong>Percentagem (Porta-Enxertos) :</strong></p>
                  <span class={`py-1 px-3 ${this.state.totalPct.boletimPortaEnxertos > 0 && this.state.totalPct.boletimPortaEnxertos + Number(this.state.boletim.percentagemEnxertoPronto) <= 100 ? 'bg-success' : 'bg-danger'} text-white`}>{this.state.totalPct.boletimPortaEnxertos || 0}%</span>
                  <p><strong>Percentagem (Enxertos-Prontos) :</strong></p>
                  <span>
                  <Input
                    type="text"
                    maxLength={6}
                    style={{ width: "100%" }}
                    className="input-1"
                    name="percentagemEnxertoPronto"
                    value={this.state.boletim.percentagemEnxertoPronto || ""}
                    label=""
                    onChange={(e) => this.handlePortaPercentage(e, 'boletim')}
                  />
                  </span>
                </div>
                {/* <hr /> */}
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimPortaEnxertos
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white middle p20 mt-140 position-relative" id="link4">
          <div className="head mb-4">
            <h2 id="parcelSettlementCharacteristics"> Características do Povoamento</h2>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <p id="parcelPopulationDetails" className="lead mb-0"><strong>Detalhes do Povoamento</strong></p>
                  <Tooltip title="Adicionar Nova Linha" color={"#333"}>
                    <span onClick={() => this.addNewRow("Detalhes do Povoamento")} className="add-plus mr-3 cursor-pointer"><i className="fas fa-plus"></i></span>
                  </Tooltip>
                </div>
                <hr />
                <div className="table-responsive table-section inner-table">
                  {
                    this.state.telkikTable.boletimDetalhesPovoamento
                  }
                </div>
              </div>
            </div>
          </div>


          <div className="bg-white middle p20 mt-140 position-relative" id="caracter">
          <Tooltip title="Inserir Casta" color={"#333"}>
            <span data-toggle="modal" data-target='#left-popup-center' onClick={() => this.openRightPopup("boletimCastas", "Castas")} className="add-plus cursor-pointer"><i className="fas fa-plus"></i></span>
          </Tooltip>
          <div className="head mb-4">
            <h2 id="Castas">Castas</h2>
          </div>
          <div className="row">
            {this.state.parcelGrapes}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive table-section inner-table">
                {
                  this.state.telkikTable.boletimCastas
                }
              </div>
            </div>
          </div>

        </div>

        </div>

        <div className="bg-white middle p20 mt-140 position-relative" id="link4">
          <Tooltip title="Inserir Artigo Matricial" color={"#333"}>
            <span onClick={() => this.openArtigoForm()} className="add-plus cursor-pointer"><i className="fas fa-plus"></i></span>
          </Tooltip>
          <div className="head mb-4">
            <h2 id="matrixArticle"> Artigo Matricial</h2>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive table-section inner-table">
              {
                this.state.telkikTable.boletimArtigoMatricial ?
                  this.state.telkikTable.boletimArtigoMatricial :
                  <p>Sem dados associados</p>
              }
              </div>
            </div>
          </div>
              
        </div>
        <div>
          {
            this.state.artigoForm
          }
        </div>


        <div className="bg-white middle p20 mt-140 position-relative" id="link4">
          <div className="head mb-4">
            <h2 id="Assinaturas"> Assinaturas</h2>
          </div>
          <div className="row">
          <div className="col-md-12">
              <div className="p-3 border">
                <div className="d-flex align-items-center justify-content-between mb-3">
                </div>
                <hr />
                <table className="table table-bordered">
                    <thead>
                      <th>Agente IVDP</th>
                      <th>Assinatura</th>
                      <th>Ações</th>
                    </thead>
                  <tbody>
                    <tr>
                      <td>
                        <select className="form-control" name="codAgente1" value={this.state.boletim.codAgente1 || ''} onChange={(e)=>this.handleChange(e,'boletim')}>
                          <option value="">Selecione</option>
                          {
                            this.props.all_list.BusUtilizador &&
                            this.props.all_list.BusUtilizador.map((item,i)=>(
                              <option key={i} disabled={item.codUtilizador == this.state.boletim.codAgente2 ? true : false} value={item.codUtilizador}>{item.nomeCompleto}</option>
                            ))
                          }
                        </select>
                      </td>
                      <td>
                        { this.state.boletim.assinaturaAgente1 && <img style={{maxHeight:"40px", maxWidth:"100px"}} src={this.state.urlassinaturaAgente1 || "data:image/jpeg;base64,"+this.state.boletim.assinaturaAgente1} />}
                      </td>
                      <td>
                        <input type="file" name="assinaturaAgente1" onChange={(e)=>this.handleAssinatura(e)} className="hidden" id="file1"/>
                        <label for="file1"><i className="fa fa-upload text-danger cursor-pointer"></i></label>
                        <label className="ml-2"><DeleteModal handleDelete={(data)=>this.handleDeleteAssinature(data)} row={{fileName:"assinaturaAgente1",selectName:"codAgente1"}}/></label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <select className="form-control" name="codAgente2" value={this.state.boletim.codAgente2 || ''} onChange={(e)=>this.handleChange(e,'boletim')}>
                          <option value="">Selecione</option>
                          {
                            this.props.all_list.BusUtilizador &&
                            this.props.all_list.BusUtilizador.map((item,i)=>(
                              <option key={i} disabled={item.codUtilizador == this.state.boletim.codAgente1 ? true : false} value={item.codUtilizador}>{item.nomeCompleto}</option>
                            ))
                          }
                        </select>
                      </td>
                      <td>
                        { this.state.boletim.assinaturaAgente2 && <img style={{maxHeight:"40px", maxWidth:"100px"}} src={this.state.urlassinaturaAgente2 || "data:image/jpg;base64,"+this.state.boletim.assinaturaAgente2} />}
                      </td>
                      <td>
                        <input type="file" name="assinaturaAgente2" onChange={(e)=>this.handleAssinatura(e)} className="hidden" id="file2"/>
                        <label for="file2"><i className="fa fa-upload text-danger cursor-pointer"></i></label>
                        <label className="ml-2"><DeleteModal handleDelete={(data)=>this.handleDeleteAssinature(data)} row={{fileName:"assinaturaAgente2",selectName:"codAgente2"}}/></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="row">
                      <div className="col-md-4">
                        <p className="mt-3">Explorador/Representante :</p>
                      </div>
                      <div className="col-md-6 input-box active-grey">
                          <Input
                            type="text"
                            style={{ width: "100%" }}
                            className="input-1"
                            name="exloradorRepresentante"
                            value={this.state.boletim.exloradorRepresentante}
                            onChange={(e) => this.handleChange(e, 'boletim')}
                          />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p className="mt-3">Data do Boletim : </p>
                      </div>
                        <div className="col-md-6">
                          <DatePicker
                              className="form-control deadlineclender input-1"
                              size="middle"
                              name="dataBoletim"
                              placeholder="Data última vistoria"
                              label="Data última vistoria"
                              format={dateShowFormat}
                              readOnly={true}
                              max={new Date()}
                              value={new Date(this.state.boletim.dataBoletim || moment(new Date()).format(dateFormat))}
                              onChange={(e)=>this.handleChange(e,"boletim")}
                          />
                        </div>
                    </div>
              </div>
            </div>
          </div>
        </div>


        <div className="modal left-popup" id="left-popup-center">
          <div className="modal-dialog modal-lg">
            {this.state.detailPopUp}
          </div>
        </div>
      </div>
    )
  }
}


export default BoletimmainFrom;